import { render, staticRenderFns } from "./RestaurantGroupMealsStats.vue?vue&type=template&id=3b19f967"
import script from "./RestaurantGroupMealsStats.vue?vue&type=script&lang=js"
export * from "./RestaurantGroupMealsStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports